export default __webpack_public_path__ + "static/media/47.dffa3cea.png";